import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {withState} from 'shared/core';
import {ConfirmationCodeFormState} from '../state';
import {Panel, Input, Button} from 'components';
import Logo from 'img/collage-logo--blue@2x.png';
import ConfirmEmailImage from 'img/confirm-email@2x.png';

const ConfirmationCodeForm = observer(({uiState}) => {
  const {confirmationCode, errors} = uiState;

  return (
    <div>
      <div className='bg-white border-bottom center mb3'>
        <a className='inline-block p2' href='https://collage.co'>
          <img src={Logo} alt='Collage' height='26'/>
        </a>
      </div>
      <div className='flex justify-content-center'>
        <Panel className='flex flex-col align-items-middle'>
          <div className='h2'>
            <FormattedMessage id='user_activation.confirmation_code.Verify your email address'/>
          </div>
          <div className='center mb3'>
            <img src={ConfirmEmailImage} alt='Confirm Email' height='117'/>
            <div>
              <FormattedMessage id="user_activation.confirmation_code.We've sent a verification code to your email. Enter it below verify your account."/>
            </div>
          </div>
          <div className='full-width'>
            <Input
              value={confirmationCode}
              onChange={(e) => uiState.updateConfirmationCode(e.target.value)}
              placeholder='000000'
              autoComplete='new-password'
              translatePlaceholder={true}
              errorMessage={errors.confirmationCode}
              maxLength={6}
            />
          </div>
          <div className='mt2 flex justify-content-center'>
            <Button size='md' trait='primary' onClick={() => uiState.submitConfirmationCode()}>
              <FormattedMessage id='user_activation.confirmation_code.Submit'/>
            </Button>
          </div>
          <div className='mt2 flex justify-content-center'>
            <a href='#' onClick={() => uiState.resendActivationEmail()}>
              <FormattedMessage id='user_activation.confirmation_code.Send new code'/>
            </a>
          </div>
        </Panel>
      </div>
    </div>
  );
});

export default withState(ConfirmationCodeForm, ConfirmationCodeFormState);
